import React, { createContext, useContext, useState, useRef, useEffect } from "react";

const SelectContext = createContext();

export function Select({ value, onValueChange, children, closeOnSelect = true }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handleOutsideClick = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [open]);

  return (
    <SelectContext.Provider value={{ value, onValueChange, open, setOpen, closeOnSelect }}>
      <div ref={containerRef} className="relative inline-block w-full text-left">
        {children}
      </div>
    </SelectContext.Provider>
  );
}

export function SelectTrigger({ children, className }) {
  const { open, setOpen } = useContext(SelectContext);
  return (
    <div
      onClick={() => setOpen(!open)}
      className={`cursor-pointer flex items-center justify-between ${className}`}
    >
      {children}
    </div>
  );
}

export function SelectValue({ placeholder }) {
  const { value } = useContext(SelectContext);
  const labelMap = {
    "en": "English",
    "ja": "日本語"
  };
  return <span>{labelMap[value] || value || placeholder}</span>;
}

export function SelectContent({ children, className, style }) {
  const { open } = useContext(SelectContext);
  if (!open) return null;

  return (
    <div
      className={`absolute z-10 mt-1 w-full rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none ${className}`}
      style={style}
    >
      <div className="py-1">{children}</div>
    </div>
  );
}

export function SelectItem({ value, children, className, closeOnSelect }) {
  const { onValueChange, setOpen, closeOnSelect: defaultCloseOnSelect } = useContext(SelectContext);
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        onValueChange(value);
        if (closeOnSelect ?? defaultCloseOnSelect) setOpen(false);
      }}
      className={`cursor-pointer select-none py-2 pl-3 pr-9 text-gray-900 hover:bg-gray-100 ${className}`}
    >
      {children}
    </div>
  );
}
